import React from "react";
import "./DropDown.scss";
import { FormControl, FormHelperText, Select } from "@material-ui/core";
import getStyles from "./getStyles";
import CancelIcon from "@material-ui/icons/Cancel";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";

const DropDown = (props: any) => {
  const classes = getStyles();

  return (
    <div className={`DropDown--input-container ${props.containerClassName}`}>
      <div className="DropDown--input-label">{props.fieldName}</div>
      <FormControl error>
        <div className="DropDown--dropDownContainer">
          <Select
            disabled={props.disabled}
            className={classes.dropDown}
            value={props.value}
            variant="outlined"
            displayEmpty
            renderValue={props.renderValue}
            onChange={props.onChange}
            error={props.errorOutline}
          >
            {props.defaultDropDownItem}
            {props.dropDownItems}
          </Select>
          {props.clickedActionButton && !props.errorOutline ? (
            <CheckCircleIcon className="InputField--checkIcon" />
          ) : props.errorOutline ? (
            <CancelIcon className="InputField--cancelIcon" />
          ) : (
            <></>
          )}
        </div>
        <FormHelperText
          className={`${classes.errorMsg} ${props.errorMessageClassName}`}
        >
          {props.errorMessage}
        </FormHelperText>
      </FormControl>
    </div>
  );
};

export default DropDown;
